import axios from "axios";
import FileDownload from "js-file-download";
import { NameChangeInfo, POAInfo, PrefilledInfo } from "../interfaces";
import { MAIN_URL } from "./UserAPI";
import { createAsyncThunk } from "@reduxjs/toolkit";

export async function submitRequest(args: {
  requestType: string;
  regNum: number;
  prefilledInfo: PrefilledInfo;
}) {
  axios.defaults.withCredentials = true;
  const response = await axios.post(
    `${MAIN_URL}/request/submit_request/${args.requestType}/${args.regNum}`,
    {
      prefilledInfo: args.prefilledInfo,
    }
  );
  const data: { result: boolean; msg: string } = response.data;
  return data;
}
export const generateForm = createAsyncThunk<any, any>(
  "FormsSlice/generateForm",
  async (
    args: {
      info: any;
      files: any;
      formType: string;
    },
    { rejectWithValue }
  ) => {
    const info = { ...args.info, otherBirthDate: null };
    const files = args.files;
    try {
      const formData = new FormData();
      formData.append("files", files);
      Object.keys(info).forEach((fieldName) => {
        console.log(fieldName, info[fieldName]);
        formData.append(fieldName, info[fieldName]);
      });

      const response = await axios({
        method: "post",
        url: `${MAIN_URL}/form/generateForm/${args.formType}`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      return response as any;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  }
);

export async function sendNotification(args: {
  fund: string;
  firstName: string;
  lastName: string;
  regNum: number;
  country: string;
}) {
  axios.defaults.withCredentials = true;
  const { firstName, lastName, regNum, fund, country } = args;

  const response = await axios.post(`${MAIN_URL}/request/files_conversion`, {
    firstName,
    lastName,
    regNum,
    fund,
    country,
  });
  const data: { result: boolean; msg: string } = response.data;
  return data;
}

export async function handleOnlineSignature(args: {
  info: PrefilledInfo | NameChangeInfo;
  blob: Blob;
  formType: string;
}) {
  axios.defaults.withCredentials = true;
  const infoJson = JSON.stringify(args.info);
  const file = new File([args.blob], "signature.png", { type: "image/png" });
  const formData = new FormData();
  formData.append("image", file);
  formData.append("info", infoJson);
  const response = await axios({
    method: "post",
    url: `${MAIN_URL}/files/handle_online_signature/${args.formType}/${args.info.requestId}`,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });

  const data: { result: boolean; msg: string } = response.data;
  return data;
}

export async function downloadFileApi(args: {
  regNum: number;
  formType: string;
  fund: string | undefined;
  bank_country?: string;
}) {
  axios.defaults.withCredentials = true;

  const response = await axios({
    url: `${MAIN_URL}/form/dowload_form/${args.formType}/${args.regNum}/${
      args.fund
    }/${args.bank_country ? args.bank_country : "__"}`,
    method: "GET",
    responseType: "blob",
  });
  if (!response.data) {
    return;
  }
  FileDownload(response.data, `${args.formType}.pdf`);

  return response;
}

export async function docusign(args: {
  regNum: number;
  fund: string;
  formType: string;
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  dob: Date;
  accountId: number;
  requestId: number | undefined;
  claimEmail: string | null;
}) {
  const {
    regNum,
    fund,
    formType,
    firstName,
    lastName,
    email,
    country,
    dob,
    accountId,
    requestId,
    claimEmail,
  } = args;

  const response: any = await axios.post(
    `${MAIN_URL}/form/docusign/${formType}/${regNum}`,
    {
      email,
      fund,
      firstName,
      lastName,
      country,
      dob,
      accountId,
      requestId,
      claimEmail,
    }
  );
  window.location.replace(response.data.url);

  return response;
}

export async function handleDocusignResult(args: any) {
  const accessToken: string | null = localStorage.getItem("accessToken");
  if (!accessToken) {
    return;
  }
  const response = await axios.post(
    `${MAIN_URL}/request/handle_docusign_result/${accessToken}`,
    {
      docusignResults: args,
    }
  );
  return response.data;
}
